/* eslint-disable no-nested-ternary */
import React, { Fragment, useContext } from 'react';
import { themes } from '@mummssoftware/common-ui';
import { GlobalContext } from '@mummssoftware/global-context/GlobalContext';
import { VisitsGlobalContext } from '@mummssoftware/global-context/VisitsGlobalContext';
import { Tooltip } from '@material-ui/core';
import RoomIcon from '@material-ui/icons/Room';
import { StyledActionIcon, IPULabel } from '../../components';
import { VisitContext } from '../Context/contexts/VisitContext';
import { InProgressDriving } from '../Context/constants';
import defaults from '../../translations/en.json';

export const VisitButton = ({ IPUButton, onClick, disabled }: any) => {
  const { appVisit } = useContext(GlobalContext);
  const { globalDrivingVisit } = useContext(VisitsGlobalContext);
  const { prepVisit, IPUVisit } = useContext(VisitContext);
  const isDrivingVisitActive =
    !IPUButton && globalDrivingVisit?.status === InProgressDriving;

  const colorRenderer = () => {
    if (isDrivingVisitActive) {
      return themes.default.palette.visit.green;
    }
    if (
      (appVisit && IPUButton && IPUVisit) ||
      (appVisit && !IPUButton && !IPUVisit)
    ) {
      return themes.default.palette.visit.green;
    } else if (prepVisit) {
      return themes.default.palette.visit.red;
    } else if (
      (appVisit && IPUButton && !IPUVisit) ||
      (appVisit && !IPUButton && IPUVisit)
    ) {
      return 'grey';
    }
    return null;
  };
  const buttonColor = colorRenderer();
  return (
    <Fragment>
      <Tooltip
        title={isDrivingVisitActive ? defaults.inProgressDrivingVisit : ''}
      >
        <span>
          <StyledActionIcon
            Icon={RoomIcon}
            htmlColor={buttonColor}
            disabled={disabled || isDrivingVisitActive}
            {...{ onClick }}
          />
        </span>
      </Tooltip>
      {IPUButton && <IPULabel color={buttonColor}>{defaults.IPU}</IPULabel>}
    </Fragment>
  );
};
